<div class="service-unavailable-layout">
  <div>
    <svg aria-hidden="true" width="82" height="82" viewBox="0 0 83 82" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.5 82C18.8563 82 0.5 63.6437 0.5 41C0.5 18.3563 18.8563 0 41.5 0C64.1437 0 82.5 18.3563 82.5 41C82.5 63.6437 64.1437 82 41.5 82ZM41.5 70.6897C57.8971 70.6897 71.1897 57.3971 71.1897 41C71.1897 24.6029 57.8971 11.3103 41.5 11.3103C25.1029 11.3103 11.8103 24.6029 11.8103 41C11.8103 57.3971 25.1029 70.6897 41.5 70.6897Z"
        fill="#5C68EC"
      />
      <path
        d="M41.5002 70.6899C57.8973 70.6899 71.1899 57.3973 71.1899 41.0002C71.1899 24.6031 57.8973 11.3105 41.5002 11.3105C25.1031 11.3105 11.8105 24.6031 11.8105 41.0002C11.8105 57.3973 25.1031 70.6899 41.5002 70.6899Z"
        fill="white"
      />
      <path
        d="M54.5059 23.1864C49.0402 23.1864 44.6094 27.6172 44.6094 33.0829C44.6094 38.5487 49.0402 42.9795 54.5059 42.9795C59.9716 42.9795 64.4025 38.5487 64.4025 33.0829C64.4025 27.6172 59.9716 23.1864 54.5059 23.1864Z"
        fill="#FFD204"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.6094 32.7998C44.6094 32.7998 52.6156 32.7998 54.5059 32.7998C56.3917 32.7998 64.4025 32.7998 64.4025 32.7998C64.4025 28.4462 61.1036 23.7336 54.5059 18.6619C47.9082 23.7785 44.6094 28.4911 44.6094 32.7998Z"
        fill="#FFD204"
      />
    </svg>
  </div>

  <div>
    <p class="text-center text-light-text max-width-375">
      Le service est momentanément indisponible, veuillez nous en excuser.
    </p>
  </div>

  <div>
    <button (click)="postChannelMessage()" nbButton status="primary" class="button-retry smb-text-default">
      Réessayer
    </button>
  </div>
</div>
